import React from "react";
import { Box, Button, Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ActionButtonDescriptor {
    key: string;
    icon?: React.ReactNode;
    label: string;
    onClick: () => void | Promise<void>;
}

interface ActionButtonsProps {
    isPopoverOpen: boolean;
    anchorEl: HTMLElement | null;
    onPopoverClose: () => void;
    buttons: ActionButtonDescriptor[];
}

const StyledButton = styled(Button)(({ theme }) => ({
    color: theme.palette.text.primary,
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
}));

export default function ActionButtons({
    isPopoverOpen,
    anchorEl,
    onPopoverClose,
    buttons,
}: ActionButtonsProps) {
    const handleClick = async (btn: ActionButtonDescriptor) => {
        try {
            await btn.onClick();
        } finally {
            onPopoverClose();
        }
    };

    return (
        <Popover
            open={isPopoverOpen}
            anchorEl={anchorEl}
            onClose={onPopoverClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                p={1}
                gap={1}
            >
                {buttons.map((btn) => (
                    <StyledButton key={btn.key} onClick={() => handleClick(btn)}>
                        {btn.icon}
                        {btn.label}
                    </StyledButton>
                ))}
            </Box>
        </Popover>
    );
}